import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TokenService } from './core/services/token.service';
import { switchMap, take } from 'rxjs/operators';

@Injectable()
export class AuthTokenInterceptor implements HttpInterceptor {

  constructor(private tokenService: TokenService) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {

    return this.tokenService.getToken().pipe(
      take(1),
      switchMap((token: any) => {

        if (token && !request.headers.has("Authorization")) {
          request = request.clone({
            setHeaders: { Authorization: `Bearer ${token}` }
          });
        }

        return next.handle(request);
      }));

  }
}
